module.exports = __webpack_public_path__ + "img/011-file.430f23d5.png";